import * as services from './experience/services.gen';

export const useExperienceApi = () => services;
